export default __webpack_public_path__ + "static/northIreland-cb3f13774f19cf3e0e5a79f059ad56cb.svg";